import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GetCancelledOrderslistBookingManagementSlice } from "../../../redux/features/BookingManagementSlice";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../../common/Loader/Loader";
import Pagination from "../../../common/pagination/PaginationCustom";
import useParamsFormat from "../../../common/Params Values format/ParamsFormat";

const OrderReturnd = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const { createDataSetParams } = useParamsFormat();
  const [pagination, setPagination] = useState([]);
  const [handleArrforPage, setHandleArrforPage] = useState(1);
  const [arr, setArr] = useState([]);
  const [page, setPage] = useState(1);
  const [getSearch, setGetSearch] = useState({
    search: "",
    fromDate: "",
    toDate: "",
    page: 1,
  });

  const { loading } = useSelector((state) => state.BookingManagement);

  useEffect(() => {
    dispatch(GetCancelledOrderslistBookingManagementSlice()).then((res) => {
      setData(res?.payload?.data);
      setPagination(res.payload.pagination);
    });
  }, []);

  useEffect(() => {
    if (Object.entries(pagination ?? {}).length > 0) {
      setArr(
        [...Array(pagination?.totalPages + 1).keys()]
          .slice(1)
          .slice(handleArrforPage - 1, handleArrforPage + 2)
      );
    }
  }, [pagination, handleArrforPage]);

  const handlePagesIncrease = () => {
    console.log("handleIncrease:", handleArrforPage);
    if (handleArrforPage + 3 <= pagination?.totalPages) {
      setHandleArrforPage((prev) => prev + 3);
    }
  };

  const handlePagesDecrease = () => {
    if (handleArrforPage > 2) {
      setHandleArrforPage((prev) => prev - 3);
    }
  };

  const FetchDataOnPages = (pageNum) => {
    setPage(pageNum);

    setGetSearch((prev) => ({ ...prev, page: pageNum }));

    const dataSet = createDataSetParams({ ...getSearch, page: pageNum });

    dispatch(GetCancelledOrderslistBookingManagementSlice(dataSet)).then((res) => {
      const dummyData = res?.payload?.data;
      setData(dummyData);
      setPagination(res.payload.pagination);
    });
  };

  return (
    <>
      <>
        <>
          <>
            {/* <div className="TitleBox">
              <h2>Booking Management</h2>
            </div>
            <div className="CommonLinks">
              <ul>
                <li>
                  <Link to={"/OrderManagment/ActiveBooking"}>
                    Active Booking
                  </Link>
                </li>
                <li>
                  <Link to={"/OrderManagment/OrderCompleted"}>
                    Completed Booking
                  </Link>
                </li>
                <li className="active">
                  <Link to={"/OrderManagment/OrderReturnd"}>
                    Cancelled Booking
                  </Link>
                </li>
              </ul>
            </div> */}
            <div className="Small-Wrapper">
              <div className="Filter justify-content-between">
                <div className="FilterLeft">
                  <div className="form-group">
                    <label>Search</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                    />
                  </div>
                  <div className="form-group">
                    <label>From Date</label>
                    <input type="date" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label>To Date</label>
                    <input type="date" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label>&nbsp;</label>
                    <button className="Button" style={{ marginRight: "10px" }}>
                      Apply
                    </button>
                    <button className="Button Cancel">
                      <i className="fa fa-refresh" />
                    </button>
                  </div>
                </div>
                {/* <div className="FilterRight">
                  <div className="form-group">
                    <label>Timeframe</label>
                    <select className="form-control">
                      <option value="select">--Select--</option>
                      <option value="select">Today</option>
                      <option value="Month">This Week</option>
                      <option value="Month">This Month</option>
                      <option value="Year">This Year</option>
                    </select>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="TableList">
              <table style={{ width: "200%" }}>
                <thead>
                  <tr>
                  <th>S.No.</th>
                  <th>Booking Id</th>
                  <th>Booking Date &amp; Time</th>
                  <th>Customer id</th>
                  <th>Customer name</th>
                  <th>Customer contact details</th>
                  <th>Delivery address</th>
                  <th>Item quantity</th>
                  <th>Amount (in TZS)</th>
                  <th>Payment Mode</th>
                  <th>Payment Status</th>
                  <th>View Booking details</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <Loader />
                  ) : Array.isArray(data) && data?.length > 0 ? (
                    data?.map((item, index) => {
                      return (
                        <tr key={index}>
                         <td>{(pagination?.currentPage - 1) * 10 + index + 1}</td>
                      <td>{item?.orderId}</td>
                      <td>{item?.createdAt?.slice(0, 10)}</td>
                      <td>{item?.userId}</td>
                      <td>{item?.customerFullName}</td>
                      <td>{item?.customerContactNumber}</td>
                      <td style={{ width: 200 }}>
                        {item?.deliveryAddress?.street},
                        {item?.deliveryAddress?.pincode} 
                      </td>
                      <td>{item?.itemQuantity}</td>
                      <td>{item?.totalAmount}</td>
                      
                      <td>{item?.paymentMode}</td>
                      <td>
                          <span className="Green">{item?.paymentStatus}</span>
                        </td>
                          {/* <td>
                        <span className="Green">Refund</span>
                      </td> */}
                          <td>
                            <div className="Actions">
                              <Link
                                className="Blue"
                                to={`/OrderManagment/OrderActiveConfirmDetails/${item?._id}`}
                              >
                                <i className="fa fa-eye" />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={13}>There is no data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        </>
        <div className="ModalBox">
          <div
            id="LogOutModal"
            className="modal fade"
            style={{ display: "none" }}
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="Decline">
                    <a
                      href="javascript:void(0);"
                      className="CloseModal"
                      data-dismiss="modal"
                    >
                      ×
                    </a>
                    <h3>Log Out</h3>
                    <p>Are you sure you want to logout?</p>
                    <h4>
                      <a href="javascript:void(0);" data-dismiss="modal">
                        no
                      </a>
                      <a href="login.html">Yes</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Pagination
            arr={arr}
            page={page}
            handlePagesIncrease={handlePagesIncrease}
            FetchDataOnPages={FetchDataOnPages}
            handlePagesDecrease={handlePagesDecrease}
          />
        </div>
      </>
    </>
  );
};

export default OrderReturnd;
